import { render, staticRenderFns } from "./searchBG.vue?vue&type=template&id=edc216e6&scoped=true&"
import script from "./searchBG.vue?vue&type=script&lang=js&"
export * from "./searchBG.vue?vue&type=script&lang=js&"
import style0 from "./searchBG.vue?vue&type=style&index=0&id=edc216e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc216e6",
  null
  
)

export default component.exports